const ptcontent = {
  header: "Physical Therapy",
  subheading: "Achieve Recovery and Mobility and Maximize Performance",
  summary:
    "Empowering your journey to wellness, our dedicated Physical Therapy services offer personalized assessments and expert treatments. Discover a tailored approach for your optimal health.",
  listOne: [
    "Assessment and diagnosis",
    "Myofascial decompression",
    "Joint mobilization",
    "Corrective exercise prescription",
    "Dry needling",
    "Spinal manipulation",
    "Exercise programming",
    "Ergonomic assessments",

  ],
};

export default ptcontent;
